import { ComponentProps, SVGProps, useContext } from 'react';
import { twMerge } from 'tailwind-merge';
import { Typography } from '../../atoms/typography/typography';
import { SidenavContext } from './sidenav';
import { Link as RouterLink, ReactNode } from '@tanstack/react-router';

type Props = {
  to: string;
  label: string;
  icon: (props: SVGProps<SVGSVGElement>) => ReactNode;
  className?: string;
} & Omit<ComponentProps<typeof RouterLink>, 'className' | 'children' | 'href'>;

export function SidenavLink(props: Props) {
  const { isFullWidth } = useContext(SidenavContext);

  const { icon: Icon, className, label } = props;

  const { icon, ...rest } = props;
  return (
    <RouterLink
      {...rest}
      className={twMerge(
        'px-12 py-8 space-x-12 transition-colors ease-out duration-200 flex items-center cursor-pointer outline-none rounded-12 [&:not([data-status=active]):hover]:bg-grayscale50',
        !isFullWidth && 'justify-center',
        className,
      )}
    >
      <Icon className={'min-w-20 w-20 h-20 fill-grayscale400'} />
      {isFullWidth && (
        <Typography
          variant="body-xs"
          weight="medium"
          className="text-grayscale400"
        >
          {label}
        </Typography>
      )}
    </RouterLink>
  );
}
